const routes = [
  {
    path: '',
    component: () => import('layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'loading',
        component: () => import('src/pages/LoadingPage.vue'),
        meta: {
          auth: false,
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('pages/IndexPage.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'promociones',
        name: 'promotions',
        component: () => import('pages/promotions/PromotionsIndex.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'hp',
        name: 'hp',
        component: () => import('pages/hp/HpIndex.vue'),
      },
      {
        path: 'serie',
        name: 'series',
        component: () => import('pages/series/SeriesIndex.vue'),
      },
      {
        path: 'tipo',
        name: 'types',
        component: () => import('pages/type/TypeIndex.vue'),
      },
      {
        path: 'listado',
        name: 'list-models',
        component: () => import('pages/ListModels.vue'),
      },
      {
        path: 'detalle/:id',
        name: 'detail',
        component: () => import('pages/DetailPage.vue'),
      },
      {
        path: 'modelos/',
        name: 'models',
        component: () => import('pages/ModelsPage.vue'),
      },
      {
        path: 'comparador/',
        name: 'comparator',
        component: () => import('pages/ComparatorPage.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'comparador-de-tractores/',
        name: 'comparator-response',
        component: () => import('pages/ComparatorResponse.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'retos/',
        name: 'challenges',
        component: () => import('pages/ChallengesPage.vue'),
      },
      {
        path: 'reto/:id',
        name: 'challenge-detail',
        component: () => import('pages/ChallengeDetail.vue'),
        children: [
          {
            path: 'subreto/:taskId',
            name: 'challenge-detail-task',
            component: () => import('pages/ChallengeDetail.vue'),
          },
        ],
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('pages/news/IndexNews.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'news/:id',
        name: 'news-view',
        component: () => import('pages/news/DetailNews.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'newsletters',
        name: 'newsletters',
        component: () => import('pages/newsletters/NewslettersIndex.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'newsletters/:id',
        name: 'newsletters-view',
        component: () => import('pages/newsletters/NewslettersView.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'machinery-applications',
        name: 'machinery-applications',
        component: () => import('pages/machinery-applications/MachineryApplicationsIndex.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'courses',
        name: 'courses',
        component: () => import('pages/courses/courses-page.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'courses/:id',
        name: 'courses-detail',
        component: () => import('pages/courses/courses-detail-page.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'courses/:id/test',
        name: 'courses-test',
        component: () => import('pages/courses/courses-test-page.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'eventos',
        name: 'events',
        component: () => import('pages/events/EventList.vue'),
      },
      {
        path: 'eventos/:eventId/agenda',
        name: 'event-agenda',
        component: () => import('pages/events/EventAgenda.vue'),
      },
      {
        path: 'eventos/:eventId/cita/nueva',
        name: 'event-appointment-new',
        component: () => import('pages/events/EventAppointmentForm.vue'),
      },
      {
        path: 'eventos/:eventId/cita/:id',
        name: 'event-appointment',
        component: () => import('pages/events/EventAppointmentDetail.vue'),
      },
      {
        path: 'eventos/:eventId/cita/:id/reservada',
        name: 'event-appointment-booked',
        component: () => import('pages/events/EventAppointmentBooked.vue'),
      },
      {
        path: 'eventos/:eventId/cita/:id/editar',
        name: 'event-appointment-edit',
        component: () => import('pages/events/EventAppointmentForm.vue'),
      },
      {
        path: 'eventos/:eventId/cita/:id/horario',
        name: 'event-appointment-schedule',
        component: () => import('pages/events/EventAppointmentSchedule.vue'),
      },
      {
        path: 'eventos/:eventId/cita/:id/actualizada',
        name: 'event-appointment-updated',
        component: () => import('pages/events/EventAppointmentUpdated.vue'),
      },
      {
        path: 'activate',
        name: 'activate',
        component: () => import('pages/login/ActivatePage.vue'),
        meta: {
          auth: false,
        },
      },
    ],
  },
  {
    path: '/auth',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'login-form',
        component: () => import('pages/login/LoginForm.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'email-recover',
        name: 'email-recover',
        component: () => import('pages/login/RecoverEmail.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'code-verification',
        name: 'code-verfication',
        component: () => import('pages/login/VerifyCode.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'change-password:id',
        name: 'change-password',
        component: () => import('pages/login/ChangePassword.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'change-password',
        name: 'change-password',
        component: () => import('pages/login/ChangePassword.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: 'register-form',
        name: 'register-form',
        component: () => import('pages/login/RegisterForm.vue'),
        meta: {
          auth: false,
        },
      },
    ],
  },
  // {
  //   path: '/admin/:rest(.*)*',
  //   name: 'admin-redirect',
  //   beforeEnter: (to) => {
  //     window.location.href = 'https://mf-app.marciano.dev/admin/' + (to.params.rest || '')
  //     return false
  //   },
  // },
  // // Always leave this as last one,
  // // but you can also remove it
  // {
  //   path: '/:catchAll(.*)*',
  //   component: () => import('pages/ErrorNotFound.vue'),
  // },
]

export default routes
